module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#F8F8F8"
    }
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.graph')))]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "height": 125,
      "options": {
        scales: {
          yAxes: [{
            ticks: {
              max: _vm.max,
              min: _vm.min
            }
          }]
        }
      },
      "chartData": _vm.grafRatinga
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c762208", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c762208"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/Graph.vue
// module id = 1410
// module chunks = 1